export default {"src":"/_next/static/media/pillWithLine_24.80d9547c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};